import Alert from '@material-ui/lab/Alert';
import React, { FC } from 'react';
import { ProcessStatus } from 'styles/ProcessStatus';

export const LoadingError: FC<{ error: string }> = ({ error }) => {
  return (
    <ProcessStatus>
      <Alert severity="error">{error}</Alert>
    </ProcessStatus>
  );
};
